import { Injectable } from '@angular/core';
import { PortalService } from './portal.service';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot } from '@angular/router';
import { GdprPortalDTO } from '../../../sb-tools/typescript/models/dto/gdpr-portal.dto';

@Injectable()
export class PortalsResolveService {
    communityName: string;

    inboxUrl: string;

    portal: GdprPortalDTO;

    portals: GdprPortalDTO[];

    portalName: string;

    user: object;

    constructor(private portalService: PortalService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
        const portalName = route.params['portalName'];
        return this.portalService.getPortal(portalName);
    }
}
